import MainTemplate from "../MainTemplate.js";
import ProfileLeftSide from "./fragments/ProfileLeftSide.js";
import { useState, useEffect, useMemo } from "react";
import PersonalDataComponent2 from "./fragments/PerosnalDataComponent2.js";
import ChangePasswordComponent from "./fragments/ChangePasswordComponent";
import Osobni_podaci from "../../../assets/Osobni_podaci.svg";
import Promijeni_lozinku from "../../../assets/Promijeni_lozinku.svg";
import deaktiviraj_racun from "../../../assets/deaktiviraj_racun.svg";
import { useDispatch, useSelector } from "react-redux";
import useColors from "../../../customHooks/useColors.js";
import DeactivateAccountComponent from "./fragments/DeactivateAccountComponent.js";
import { asyncActions as countriesAsyncActions } from "../../../store/slices/countriesSlice.js";
import { asyncActions as userAsyncActions } from "../../../store/slices/userSlice.js";
import { asyncActions as citiesAsyncActions } from "../../../store/slices/citySlice.js";

const ProfileView = () => {
  const dispatch = useDispatch();
  ///////////////////////////////////////////////GET TIERS

  const tierState = useSelector((state) => state.tierState);
  const userState = useSelector((state) => state.userState);

  const currentTier = tierState.tiers.find(
    (tier) => tier.id === userState.currentPeriod.tier
  );

  ///////////////////////////////////////////////STATES

  const [selectedRegion, setSelectedRegion] = useState("personalData");

  const [currentColors] = useColors();

  ///////////////////////////////////////////////VARIABLES
  let profileRegions = [
    {
      name: "personalData",
      icon: Osobni_podaci,
      component: (props) => <PersonalDataComponent2 {...props} />,
      getters: [
        countriesAsyncActions.getCountries,
        userAsyncActions.getUserInfo,
        citiesAsyncActions.getCities
      ],
      onSelect: () => {}
    },
    {
      name: "changePassword",
      icon: Promijeni_lozinku,
      component: (props) => <ChangePasswordComponent {...props} />,
      getters: [],
      onSelect: () => {}
    },
    {
      name: "deactivateAccount",
      icon: deaktiviraj_racun,
      component: (props) => <DeactivateAccountComponent {...props} />,
      color: currentColors.octonary,
      getters: [],
      onSelect: () => {}
    },
  ];

  profileRegions = profileRegions.map((region) => {
    return { ...region, isSelected: region.name === selectedRegion };
  });

  const selectedProfileRegion = profileRegions.find(
    (region) => region.isSelected === true
  );
  const selectedProfileRegionName = selectedProfileRegion.name;

  useEffect(() => {
    let promises = [];
    const currentDispatchers = selectedProfileRegion?.getters ?? [];
    currentDispatchers.forEach((dispatcher) => {
      const promise = dispatch(dispatcher());
      promises.push(promise);
    });

    const onSelect = selectedProfileRegion.onSelect ?? (() => {})

    onSelect();

    return () => {
      promises.forEach((promise) => {
        if (promise) {
          promise.abort();
        }
      });
    };
  }, [selectedProfileRegionName]);

  const SelectedComponent = useMemo(() => {
    return (props) => {
      return <selectedProfileRegion.component {...props} />;
    };
  }, [selectedProfileRegionName]);

  return (
    <MainTemplate
      title="profile"
      showBadge
      image={{ src: currentTier?.userImageCode }}
      LeftSideComponent={() => (
        <ProfileLeftSide
          selectedRegion={selectedRegion}
          setSelectedRegion={setSelectedRegion}
          profileRegions={profileRegions}
        />
      )}
      MainComponent={SelectedComponent}
      getUserInfo={false} //jer ide na nizim komponentama radi region selectora
      getTierInfo={false}
    />
  );
};

export default ProfileView;
